const CouponParentTypes = Object.freeze({
  Referred: 'Referred',
  Affiliate: 'Affiliate',
});

export default CouponParentTypes;
